export class Bin {
    constructor({ left, centre, right }) {
        this.dataPoints = [];
        this.leftClosed = true;
        this.rightClosed = false;
        this.frequency = 0;
        this.relFrequency = 0;
        this.relFrequencyPerUnit = 0;
        this.left = left;
        this.right = right;
        this.centre = centre;
        this.size = right - left;
    }
    contains(value) {
        return (((this.leftClosed && value >= this.left) || (!this.leftClosed && value > this.left))
            &&
                ((this.rightClosed && value <= this.right) || (!this.rightClosed && value < this.right)));
    }
    setFrequencies(n) {
        this.frequency = this.dataPoints.length;
        this.relFrequency = this.frequency / n;
        this.relFrequencyPerUnit = this.relFrequency / (this.right - this.left);
    }
}
export function calculateCustomBins({ orderedSample, boundaries }) {
    if (boundaries.length <= 1) {
        return [];
    }
    boundaries.sort((a, b) => a - b);
    let bins = [];
    let previousPoint = boundaries[0];
    for (const point of boundaries.slice(1)) {
        bins.push(new Bin({
            left: previousPoint,
            centre: (point + previousPoint) / 2.0,
            right: point
        }));
        previousPoint = point;
    }
    setBinBoundsOpenOrClosed(bins);
    fillBins(bins, orderedSample);
    return bins;
}
export function calculateUniformBins({ orderedSample, h, // bin width
pivotCentre, // centre of any of the bins = c_i +- nh
 }) {
    const min = orderedSample[0];
    const max = orderedSample[orderedSample.length - 1];
    const nLeft = Math.ceil((pivotCentre - min) / h - 1 / 2);
    const nRight = Math.ceil((max - pivotCentre) / h - 1 / 2);
    const bins = [];
    let prevBin = undefined;
    for (let i = -nLeft; i <= nRight; i++) {
        let centre = pivotCentre + i * h;
        const bin = new Bin({
            left: prevBin !== undefined ? prevBin.right : centre - h / 2,
            centre: centre,
            right: centre + h / 2,
        });
        bins.push(bin);
        prevBin = bin;
    }
    setBinBoundsOpenOrClosed(bins);
    fillBins(bins, orderedSample);
    return bins;
}
function setBinBoundsOpenOrClosed(bins) {
    for (let b of bins) {
        b.leftClosed = true;
        b.rightClosed = false;
    }
    if (bins.length > 0) {
        bins[bins.length - 1].rightClosed = true;
    }
}
function fillBins(bins, orderedSample) {
    if (bins.length === 0 || orderedSample.length === 0) {
        return;
    }
    let binIndex = 0;
    let bin = bins[binIndex];
    for (let r of orderedSample) {
        while (!bin.contains(r) && binIndex < bins.length - 1) {
            binIndex += 1;
            bin = bins[binIndex];
        }
        if (binIndex == bins.length - 1) {
            if (bin.contains(r)) {
                bin.dataPoints.push(r);
            }
            else {
                // throw Error("Not all datapoints placed into bins.")
            }
        }
        else {
            bin.dataPoints.push(r);
        }
    }
    for (let b of bins) {
        b.setFrequencies(orderedSample.length);
    }
}
export function calculateBinsHints(stats) {
    const methods = [binsHintSqrt, binsHintSturges, binsHintScott, binsHintFreedmanDiaconis];
    return methods.map(m => m(stats));
}
function binsHintSqrt(stats) {
    const n = stats.size;
    const m = Math.ceil(Math.sqrt(n));
    return {
        name: 'sqrt',
        m: m,
        h: stats.range / m,
    };
}
function binsHintSturges(stats) {
    const n = stats.size;
    const m = 1 + Math.ceil(Math.log2(n));
    return {
        name: 'Sturges',
        m: m,
        h: stats.range / m,
    };
}
function binsHintScott(stats) {
    const n = stats.size;
    const std = isNaN(stats.sampleStd) ? 1 : stats.sampleStd;
    const h = (3.49 * std) / Math.pow(n, 1 / 3);
    return {
        name: 'Scott',
        h: h,
        m: Math.ceil(stats.range / h),
    };
}
function binsHintFreedmanDiaconis(stats) {
    const n = stats.size;
    const h = (2 * stats.iqr) / Math.pow(n, 1 / 3);
    return {
        name: 'Freedman-Diaconis',
        h: h,
        m: Math.ceil(stats.range / h),
    };
}
//# sourceMappingURL=bins.js.map